// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* background-color: #F2F3FC !important; */
}

/* .material-symbols-outlined{
	font-size: 14px !important;
} */
/* .btn-primary{
	background-color: #358696 !important;
    border-color: #358696 !important;
} */

/* .btn-outline-primary{
	color:#358696 ;
	border-color:#358696;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#358696;
	color:#fff;
} */

/* .chargingMainDiv .btn-outline-primary {
  color: #358696 !important;
  border-color: #358696 !important;
}

.chargingMainDiv .btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
  background-color: #358696 !important;
  color: #fff !important;
}

.highlightBoxKpi .btn-outline-primary {
  color: #358696 !important;
  border-color: #358696 !important;
}

.highlightBoxKpi .btn-outline-primary:hover,
.btn-outline-primary:focus,
.btn-outline-primary:visited,
.btn-outline-primary:active,
.btn-check:checked+.btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check)+.btn:active {
  background-color:  #358696 !important;
  color: #fff !important;
} */

.chargingMainDiv .btn-primary {
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/* k */
.chargingMainDiv .btn-outline-primary {
  border-color: #358696 !important;
  color: #358696 !important;
}


.chargingMainDiv .ev_filter_icon {
  background: #fff !important;
  color: #348393 !important;
}


.chargingMainDiv .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  color: #fff !important;
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/*********************** Slow Button *************************/
.kpiSlowBTN .btn-outline-primary {
  /* color:#358696; */
  border-color: #358696 !important;
}

.kpiSlowBTN .btn-check:checked+.btn:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible,
.btn:first-child:active:focus-visible,
:not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
}

.kpiSlowBTN .btn-outline-primary {
  --bs-btn-color: #358696 !important;
  --bs-btn-border-color: #358696 !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #358696 !important;
  --bs-btn-hover-border-color: #358696 !important;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #358696 !important;
  --bs-btn-active-border-color: #358696 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #358696 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #358696 !important;
  --bs-gradient: none;
}

.kpiSlowBTN .btn-outline-primary:not(:disabled):not(.disabled):active,
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show>.btn-outline-primary.dropdown-toggle {
  /* color: #fff; */
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/* .kpiSlowBTN .ev_SButton {
    background: none !important;
    color: #348393 !important;
  } */
.kpiSlowBTN .ev_SButton {
  background: none !important;
  color: #7b7878 !important;
  border-color: #7b7878 !important;
}

.kpiSlowBTN .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  color: #fff !important;
  background-color: #358696 !important;
  border-color: #358696 !important;
}

.kpiSlowBTN .btn-outline-primary:hover {
  background-color: #358696 !important;
  border-color: #358696 !important;
}

/*********************** Slow Button Ends *************************/


/*********************** Fast Button *************************/
.kpiFastBTN .btn-outline-warning {
  /* color:#FFA650; */
  /* border-color:#FFA650 !important; */
}

.kpiFastBTN .btn-check:checked+.btn:focus-visible,
.btn.active:focus-visible,
.btn.show:focus-visible,
.btn:first-child:active:focus-visible,
:not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
}

.kpiFastBTN .btn-outline-warning {
  --bs-btn-color: #FFA650 !important;
  --bs-btn-border-color: #FFA650 !important;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #FFA650 !important;
  --bs-btn-hover-border-color: #FFA650 !important;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #FFA650 !important;
  --bs-btn-active-border-color: #FFA650 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #FFA650 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #FFA650 !important;
  --bs-gradient: none;
}

/* .kpiFastBTN .ev_FButton {
  background: none !important;
  color: #FFA650 !important;
} */
.kpiFastBTN .ev_FButton {
  background: none !important;
  /* color: #FFA650 !important; */
  /* background: #7b7878 !important; */
  /* border: #7b7878; */
  border-color: #7b7878;
}

.kpiFastBTN .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target {
  color: #fff !important;
  background-color: #FFA650;
  border-color: #FFA650;
}


/*********************** Fast Button Ends *************************/

has context menu .bg-white {
  background-color: #fff;
}

.chargingMainDiv {
  margin-top: 80px;
}

.chargingWidget {
  background: #fff;
  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
  border-radius: 5px;
}

.chargingWidgetIcon img {
  width: 50px;
  height: 50px;
}

.chargingWidgetIcon1 img {
  width: 35px;
  height: 35px;
}

.chargingWidgetIcon-32 img {
  width: 32px;
  height: 32px;
}

.chargingTitleBg {
  font-size: 1em;
  color: #0E3157;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: left;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
}

.chargingTitleChart {
  font-size: 0.8em;
  color: #0E3157;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: left;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
}

.chargingChartbox {
  background: #FFFFFF;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  color: #353535;
  min-height: 280px;
  border-radius: 5px;
}

.wd {
  min-height: 328px !important;
}

.wd_4_charts {
  min-height: 307px !important;
}

.highlightBoxKpi {
  min-height: 310px !important;
}

.highlightTableSec {
  min-height: 310px !important;
}

.chargingChartHGT {
  padding: 10px;
}

.chargingH5 .h5 {
  font-size: 1rem !important;
}

.chargingKpiSmallTxt {
  font-size: 77% !important;
  line-height: 1em !important;
}

.tableContent table tr td {
  font-size: 0.8em;
}

.chargingFilterForm>.form-label {
  font-size: 0.825em;
}

.chargingHeadfont {
  font-size: 1.8rem;
}

.topRightDropMenu .dropdown-menu[data-bs-popper] {
  right: 0 !important;
  left: auto;
}

/********************  *********************/

.contentScroll {
  /* overflow-y: scroll; */
  /* height:150px; */
}

.chargingWidget p {
  line-height: 1rem !important;
}

.chargingWidget p small {
  font-size: 80% !important;
}

/***************************** Toggle Switch ***************************/
.toggleBtn .form-switch .form-check-input:checked:before {
  content: "F";
  position: absolute;
  width: 20px;
  height: 10px;
  padding-left: 20px;
  margin-top: -1px;
  font-size: 0.7em;
}

.toggleBtn .form-switch .form-check-input:before {
  content: "S";
  position: absolute;
  width: 20px;
  height: 10px;
  padding-left: 5px;
  margin-top: -1px;
  font-size: 0.7em;
}

.toggleBtn .form-switch .form-check-input {
  color: #358696 !important;
}

/* k */
.toggleBtn .toggle-button-cover {
  position: relative;
  top: 8px;
  /* display: table-cell; */
  /* width: 200px; */
  /* height: 140px; */
  /* box-sizing: border-box; */
}

.dropdownSelectBtnCharging {
  width: fit-content;
}

.toggleBtn .button-cover {
  /* height: 100px; */
  /* margin: 20px; */
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.toggleBtn .button-cover:before {
  /* counter-increment: button-counter; */
  /* content: counter(button-counter); */
  /* position: absolute; */
  /* right: 0; */
  /* bottom: 0; */
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.toggleBtn .button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.toggleBtn .buttonbtn {
  position: relative;
  top: 50%;
  width: 50px;
  /* height: 36px; */
  /* margin: -20px auto 0 auto; */
  /* overflow: hidden; */
}

.toggleBtn .buttonbtn.r,
.buttonbtn.r .layer {
  border-radius: 100px;
}

.toggleBtn .button.b2 {
  border-radius: 2px;
}

.toggleBtn .checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.toggleBtn .knobs {
  z-index: 2;
}

.toggleBtn .layer {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}

/* Button 1 */
#button-1 .knobs:before {
  content: "S";
  position: absolute;
  /* top: 2px; */
  /* left: 4px; */
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 6px 4px;
  background-color: #358696;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#button-1 .checkbox:checked+.knobs:before {
  content: "F";
  /* left: 25px; */
  left: 30px;
  background-color: #FFA650;
}

#button-1 .checkbox:checked~.layer {
  background-color: #fcebeb;
}

#button-1 .knobs,
#button-1 .knobs:before,
#button-1 .layer {
  transition: 0.3s ease all;
}

/* k */


/***************************** PageTwo *******************************/

/*************************  *****************************/
.kpiNotificationSlow {
  color: #358696;
  font-size: 0.7em;
  font-weight: 500;
}

.kpiNotificationFast {
  color: #FFA650;
  font-size: 0.7em;
  font-weight: 500;
}

.kpiNotificationBoth {
  color: #72D817;
  font-size: 0.7em;
  font-weight: 500;
}

/* media queries start here */

@media (min-width: 1440px) {
  .col205 {
    flex: 0 0 auto;
    width: 20% !important;
  }
}

@media (max-width: 1440px) {
  .highlightTableSec {
    min-height: 310px !important;
  }
}

@media (min-width: 1336px) {
  .col205 {
    flex: 0 0 auto;
    width: 20% !important;
  }
}


@media (max-width: 1024px) {
  .highlightTableSec {
    min-height: 330px !important;
  }
}


@media (min-width: 992px) {
  .col205 {
    flex: 0 0 auto;
    width: 20% !important;
  }
}


@media (min-width: 836px) {
  /* .navbar-expand-sm { */
  /* flex-wrap: nowrap !important; */
  /* justify-content: flex-start !important; */
  /* } */
}

@media screen and (max-width: 740px) {
  .chargingTitleBg {
    font-size: 0.9em;
  }
}


@media screen and (max-width: 720px) {
  /* .chargingMainDiv{ */
  /* margin-top:124px; */
  /* } */
}

@media screen and (max-width: 480px) {
  /* .chargingMainDiv{ */
  /* margin-top:155px; */
  /* } */
}

@media screen and (max-width: 480px) {

  .chargingHeadfont {
    font-size: 1rem;
  }

  .chargingTitleBg {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 320px) {}

.highlight_five {
  margin: auto;
}

.text_bottom {
  margin-bottom: '-16px !important';
  display: none;
  z-index: 1;
}

.btn-infotable:active {
  color: black;
  background-color: #fff;
  border-color: #32879c;

}

/* .btn:not(:disabled):not(.disabled) {
  cursor: pointer;
  color: #fff;
  color: black;
  background: none;
} */`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Jupiter/Charginganalysis_Jupiter/ChargingPageCustom_Jupiter.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;AAC5C;;AAEA;;GAEG;AACH;;;GAGG;;AAEH;;;;;;;GAOG;;AAEH;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAkCG;;AAEH;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,MAAM;AACN;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;;AAGA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;;AAGA;;;;;;;EAOE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,uCAAuC;EACvC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;EAGE,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;KAGK;AACL;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA,mEAAmE;;;AAGnE,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;;;;;EAKE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,sCAAsC;EACtC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;;;GAGG;AACH;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;;AAGA,mEAAmE;;AAEnE;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,4CAA4C;;AAE5C;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,wEAAwE;AACxE;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,MAAM;AACN;EACE,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,sCAAsC;EACtC,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,MAAM;;;AAGN,sEAAsE;;AAEtE,yDAAyD;AACzD;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;;AAE7B;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;;AAGA;EACE;IACE,4BAA4B;EAC9B;AACF;;;AAGA;EACE;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;;AAGA;EACE,wBAAwB;EACxB,kCAAkC;EAClC,4CAA4C;EAC5C,MAAM;AACR;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,MAAM;AACR;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,sCAAsC;;AAEtC;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;;AAEvB;;AAEA;;;;;GAKG","sourcesContent":["body {\n  /* background-color: #F2F3FC !important; */\n}\n\n/* .material-symbols-outlined{\n\tfont-size: 14px !important;\n} */\n/* .btn-primary{\n\tbackground-color: #358696 !important;\n    border-color: #358696 !important;\n} */\n\n/* .btn-outline-primary{\n\tcolor:#358696 ;\n\tborder-color:#358696;\n}\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\n\tbackground-color:#358696;\n\tcolor:#fff;\n} */\n\n/* .chargingMainDiv .btn-outline-primary {\n  color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n.chargingMainDiv .btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:visited,\n.btn-outline-primary:active,\n.btn-check:checked+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n  background-color: #358696 !important;\n  color: #fff !important;\n}\n\n.highlightBoxKpi .btn-outline-primary {\n  color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n.highlightBoxKpi .btn-outline-primary:hover,\n.btn-outline-primary:focus,\n.btn-outline-primary:visited,\n.btn-outline-primary:active,\n.btn-check:checked+.btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check)+.btn:active {\n  background-color:  #358696 !important;\n  color: #fff !important;\n} */\n\n.chargingMainDiv .btn-primary {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n/* k */\n.chargingMainDiv .btn-outline-primary {\n  border-color: #358696 !important;\n  color: #358696 !important;\n}\n\n\n.chargingMainDiv .ev_filter_icon {\n  background: #fff !important;\n  color: #348393 !important;\n}\n\n\n.chargingMainDiv .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target {\n  color: #fff !important;\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n/*********************** Slow Button *************************/\n.kpiSlowBTN .btn-outline-primary {\n  /* color:#358696; */\n  border-color: #358696 !important;\n}\n\n.kpiSlowBTN .btn-check:checked+.btn:focus-visible,\n.btn.active:focus-visible,\n.btn.show:focus-visible,\n.btn:first-child:active:focus-visible,\n:not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n}\n\n.kpiSlowBTN .btn-outline-primary {\n  --bs-btn-color: #358696 !important;\n  --bs-btn-border-color: #358696 !important;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #358696 !important;\n  --bs-btn-hover-border-color: #358696 !important;\n  --bs-btn-focus-shadow-rgb: 13, 110, 253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #358696 !important;\n  --bs-btn-active-border-color: #358696 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #358696 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #358696 !important;\n  --bs-gradient: none;\n}\n\n.kpiSlowBTN .btn-outline-primary:not(:disabled):not(.disabled):active,\n.btn-outline-primary:not(:disabled):not(.disabled).active,\n.show>.btn-outline-primary.dropdown-toggle {\n  /* color: #fff; */\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n/* .kpiSlowBTN .ev_SButton {\n    background: none !important;\n    color: #348393 !important;\n  } */\n.kpiSlowBTN .ev_SButton {\n  background: none !important;\n  color: #7b7878 !important;\n  border-color: #7b7878 !important;\n}\n\n.kpiSlowBTN .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target {\n  color: #fff !important;\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n.kpiSlowBTN .btn-outline-primary:hover {\n  background-color: #358696 !important;\n  border-color: #358696 !important;\n}\n\n/*********************** Slow Button Ends *************************/\n\n\n/*********************** Fast Button *************************/\n.kpiFastBTN .btn-outline-warning {\n  /* color:#FFA650; */\n  /* border-color:#FFA650 !important; */\n}\n\n.kpiFastBTN .btn-check:checked+.btn:focus-visible,\n.btn.active:focus-visible,\n.btn.show:focus-visible,\n.btn:first-child:active:focus-visible,\n:not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n}\n\n.kpiFastBTN .btn-outline-warning {\n  --bs-btn-color: #FFA650 !important;\n  --bs-btn-border-color: #FFA650 !important;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #FFA650 !important;\n  --bs-btn-hover-border-color: #FFA650 !important;\n  --bs-btn-focus-shadow-rgb: 255, 193, 7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #FFA650 !important;\n  --bs-btn-active-border-color: #FFA650 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #FFA650 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #FFA650 !important;\n  --bs-gradient: none;\n}\n\n/* .kpiFastBTN .ev_FButton {\n  background: none !important;\n  color: #FFA650 !important;\n} */\n.kpiFastBTN .ev_FButton {\n  background: none !important;\n  /* color: #FFA650 !important; */\n  /* background: #7b7878 !important; */\n  /* border: #7b7878; */\n  border-color: #7b7878;\n}\n\n.kpiFastBTN .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target {\n  color: #fff !important;\n  background-color: #FFA650;\n  border-color: #FFA650;\n}\n\n\n/*********************** Fast Button Ends *************************/\n\nhas context menu .bg-white {\n  background-color: #fff;\n}\n\n.chargingMainDiv {\n  margin-top: 80px;\n}\n\n.chargingWidget {\n  background: #fff;\n  box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n  border-radius: 5px;\n}\n\n.chargingWidgetIcon img {\n  width: 50px;\n  height: 50px;\n}\n\n.chargingWidgetIcon1 img {\n  width: 35px;\n  height: 35px;\n}\n\n.chargingWidgetIcon-32 img {\n  width: 32px;\n  height: 32px;\n}\n\n.chargingTitleBg {\n  font-size: 1em;\n  color: #0E3157;\n  font-weight: 500;\n  margin-bottom: 10px;\n  text-align: left;\n  background: #E0E0E0;\n  border-radius: 5px 5px 0 0;\n}\n\n.chargingTitleChart {\n  font-size: 0.8em;\n  color: #0E3157;\n  font-weight: 500;\n  margin-bottom: 10px;\n  text-align: left;\n  background: #E0E0E0;\n  border-radius: 5px 5px 0 0;\n}\n\n.chargingChartbox {\n  background: #FFFFFF;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  color: #353535;\n  min-height: 280px;\n  border-radius: 5px;\n}\n\n.wd {\n  min-height: 328px !important;\n}\n\n.wd_4_charts {\n  min-height: 307px !important;\n}\n\n.highlightBoxKpi {\n  min-height: 310px !important;\n}\n\n.highlightTableSec {\n  min-height: 310px !important;\n}\n\n.chargingChartHGT {\n  padding: 10px;\n}\n\n.chargingH5 .h5 {\n  font-size: 1rem !important;\n}\n\n.chargingKpiSmallTxt {\n  font-size: 77% !important;\n  line-height: 1em !important;\n}\n\n.tableContent table tr td {\n  font-size: 0.8em;\n}\n\n.chargingFilterForm>.form-label {\n  font-size: 0.825em;\n}\n\n.chargingHeadfont {\n  font-size: 1.8rem;\n}\n\n.topRightDropMenu .dropdown-menu[data-bs-popper] {\n  right: 0 !important;\n  left: auto;\n}\n\n/********************  *********************/\n\n.contentScroll {\n  /* overflow-y: scroll; */\n  /* height:150px; */\n}\n\n.chargingWidget p {\n  line-height: 1rem !important;\n}\n\n.chargingWidget p small {\n  font-size: 80% !important;\n}\n\n/***************************** Toggle Switch ***************************/\n.toggleBtn .form-switch .form-check-input:checked:before {\n  content: \"F\";\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  padding-left: 20px;\n  margin-top: -1px;\n  font-size: 0.7em;\n}\n\n.toggleBtn .form-switch .form-check-input:before {\n  content: \"S\";\n  position: absolute;\n  width: 20px;\n  height: 10px;\n  padding-left: 5px;\n  margin-top: -1px;\n  font-size: 0.7em;\n}\n\n.toggleBtn .form-switch .form-check-input {\n  color: #358696 !important;\n}\n\n/* k */\n.toggleBtn .toggle-button-cover {\n  position: relative;\n  top: 8px;\n  /* display: table-cell; */\n  /* width: 200px; */\n  /* height: 140px; */\n  /* box-sizing: border-box; */\n}\n\n.dropdownSelectBtnCharging {\n  width: fit-content;\n}\n\n.toggleBtn .button-cover {\n  /* height: 100px; */\n  /* margin: 20px; */\n  background-color: #fff;\n  box-shadow: 0 10px 20px -8px #c5d6d6;\n  border-radius: 4px;\n}\n\n.toggleBtn .button-cover:before {\n  /* counter-increment: button-counter; */\n  /* content: counter(button-counter); */\n  /* position: absolute; */\n  /* right: 0; */\n  /* bottom: 0; */\n  color: #d7e3e3;\n  font-size: 12px;\n  line-height: 1;\n  padding: 5px;\n}\n\n.toggleBtn .button-cover,\n.knobs,\n.layer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.toggleBtn .buttonbtn {\n  position: relative;\n  top: 50%;\n  width: 50px;\n  /* height: 36px; */\n  /* margin: -20px auto 0 auto; */\n  /* overflow: hidden; */\n}\n\n.toggleBtn .buttonbtn.r,\n.buttonbtn.r .layer {\n  border-radius: 100px;\n}\n\n.toggleBtn .button.b2 {\n  border-radius: 2px;\n}\n\n.toggleBtn .checkbox {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.toggleBtn .knobs {\n  z-index: 2;\n}\n\n.toggleBtn .layer {\n  width: 100%;\n  background-color: #ebf7fc;\n  transition: 0.3s ease all;\n  z-index: 1;\n}\n\n/* Button 1 */\n#button-1 .knobs:before {\n  content: \"S\";\n  position: absolute;\n  /* top: 2px; */\n  /* left: 4px; */\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1;\n  padding: 6px 4px;\n  background-color: #358696;\n  border-radius: 50%;\n  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n}\n\n#button-1 .checkbox:checked+.knobs:before {\n  content: \"F\";\n  /* left: 25px; */\n  left: 30px;\n  background-color: #FFA650;\n}\n\n#button-1 .checkbox:checked~.layer {\n  background-color: #fcebeb;\n}\n\n#button-1 .knobs,\n#button-1 .knobs:before,\n#button-1 .layer {\n  transition: 0.3s ease all;\n}\n\n/* k */\n\n\n/***************************** PageTwo *******************************/\n\n/*************************  *****************************/\n.kpiNotificationSlow {\n  color: #358696;\n  font-size: 0.7em;\n  font-weight: 500;\n}\n\n.kpiNotificationFast {\n  color: #FFA650;\n  font-size: 0.7em;\n  font-weight: 500;\n}\n\n.kpiNotificationBoth {\n  color: #72D817;\n  font-size: 0.7em;\n  font-weight: 500;\n}\n\n/* media queries start here */\n\n@media (min-width: 1440px) {\n  .col205 {\n    flex: 0 0 auto;\n    width: 20% !important;\n  }\n}\n\n@media (max-width: 1440px) {\n  .highlightTableSec {\n    min-height: 310px !important;\n  }\n}\n\n@media (min-width: 1336px) {\n  .col205 {\n    flex: 0 0 auto;\n    width: 20% !important;\n  }\n}\n\n\n@media (max-width: 1024px) {\n  .highlightTableSec {\n    min-height: 330px !important;\n  }\n}\n\n\n@media (min-width: 992px) {\n  .col205 {\n    flex: 0 0 auto;\n    width: 20% !important;\n  }\n}\n\n\n@media (min-width: 836px) {\n  /* .navbar-expand-sm { */\n  /* flex-wrap: nowrap !important; */\n  /* justify-content: flex-start !important; */\n  /* } */\n}\n\n@media screen and (max-width: 740px) {\n  .chargingTitleBg {\n    font-size: 0.9em;\n  }\n}\n\n\n@media screen and (max-width: 720px) {\n  /* .chargingMainDiv{ */\n  /* margin-top:124px; */\n  /* } */\n}\n\n@media screen and (max-width: 480px) {\n  /* .chargingMainDiv{ */\n  /* margin-top:155px; */\n  /* } */\n}\n\n@media screen and (max-width: 480px) {\n\n  .chargingHeadfont {\n    font-size: 1rem;\n  }\n\n  .chargingTitleBg {\n    font-size: 0.9em;\n  }\n}\n\n@media screen and (max-width: 320px) {}\n\n.highlight_five {\n  margin: auto;\n}\n\n.text_bottom {\n  margin-bottom: '-16px !important';\n  display: none;\n  z-index: 1;\n}\n\n.btn-infotable:active {\n  color: black;\n  background-color: #fff;\n  border-color: #32879c;\n\n}\n\n/* .btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n  color: #fff;\n  color: black;\n  background: none;\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
